var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14311_302708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14311_302708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_14311_302708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_14311_302708)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8364 5.05287H16.5387V4.3922C16.5387 3.21099 15.5195 2.25 14.2667 2.25H10.1813C8.92848 2.25 7.90926 3.21099 7.90926 4.3922V5.05287H3.61152C3.29301 5.05287 3.03821 5.29312 3.03821 5.59343C3.03821 5.89374 3.29301 6.13398 3.61152 6.13398H4.64774V18.835C4.64774 20.4286 6.02369 21.726 7.71391 21.726H16.7341C18.4243 21.726 19.8002 20.4286 19.8002 18.835V6.13398H20.8364C21.1549 6.13398 21.4098 5.89374 21.4098 5.59343C21.4098 5.29312 21.1549 5.05287 20.8364 5.05287ZM9.05589 4.3922C9.05589 3.8076 9.56125 3.33111 10.1813 3.33111H14.2667C14.8867 3.33111 15.3921 3.8076 15.3921 4.3922V5.05287H9.05589V4.3922ZM16.7341 20.6449C17.7915 20.6449 18.6536 19.832 18.6536 18.835H18.6578V6.13398H5.79436V18.835C5.79436 19.832 6.65646 20.6449 7.71391 20.6449H16.7341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2239 18.7069C12.5425 18.7069 12.7973 18.4667 12.7973 18.1664V8.61258C12.7973 8.31227 12.5425 8.07202 12.2239 8.07202C11.9054 8.07202 11.6506 8.31227 11.6506 8.61258V18.1624C11.6506 18.4627 11.9054 18.7069 12.2239 18.7069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48262 18.1102C8.80112 18.1102 9.05593 17.87 9.05593 17.5697V9.20511C9.05593 8.9048 8.80112 8.66455 8.48262 8.66455C8.16411 8.66455 7.9093 8.9048 7.9093 9.20511V17.5697C7.9093 17.87 8.16836 18.1102 8.48262 18.1102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9654 18.1102C16.2839 18.1102 16.5387 17.87 16.5387 17.5697V9.20511C16.5387 8.9048 16.2839 8.66455 15.9654 8.66455C15.6469 8.66455 15.3921 8.9048 15.3921 9.20511V17.5697C15.3921 17.87 15.6469 18.1102 15.9654 18.1102Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trashBin.7e33fdb4bfd286df23fe24530a839923.svg";
export { ForwardRef as ReactComponent };